import { Typography, Stack, TextField, Button, Box } from '@mui/material';
import { Timestamp } from 'firebase/firestore';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { UserContext } from '../components/UserContex';
import { useState, useContext } from 'react';
import Alert from '@mui/material/Alert';
import { setPlaytime } from '../services/Playtime';
import { hasAccountAlias } from '../services/Account';

const initialRegisterObj = { hours: 0, minutes: 0, date: new Date() };

const Register = () => {
  const [registerObj, setRegisterObj] = useState(initialRegisterObj);
  const [lastRegistationObj, setLastRegistrationObj] = useState();
  const [registerAlert, setRegisterAlert] = useState({ open: false });

  const user = useContext(UserContext);

  const registerPlaytime = async (registerObj) => {
    if (!user) {
      setRegisterAlert({ open: true, type: 'error', message: 'Du er ikke logget inn. Kan ikke registre tid 😓' });
      return;
    }

    if (Number(registerObj.hours) > 10 || Number(registerObj.minutes) > 60) {
      setRegisterAlert({
        open: true,
        type: 'warning',
        message: 'Ugyldig antall timer eller minutter (maks 10 timer og 60 minutter)',
      });
      return;
    }

    if (
      registerObj.date !== lastRegistationObj?.date &&
      registerObj.hours !== lastRegistationObj?.hours &&
      registerObj.minutes !== lastRegistationObj?.minutes
    ) {
      let uid = user.uid;
      await hasAccountAlias(uid).then((alias) => {
        if (alias) uid = alias;
      });

      setPlaytime({
        registered: Timestamp.fromDate(new Date()),
        date: Timestamp.fromDate(registerObj.date),
        hours: Number(registerObj.hours),
        minutes: Number(registerObj.minutes),
        user: uid,
      })
        .then((response) => {
          setRegisterAlert({ open: true, type: 'success', message: 'Tiden er blitt registrert!' });
          // set last registration obj for duplicate control
          setLastRegistrationObj(registerObj);
          setRegisterObj(initialRegisterObj);
        })
        .catch((error) => setRegisterAlert({ open: true, type: 'warning', message: 'Kunne ikke registrere tiden 😭' }));
      localStorage.removeItem('summaryObj');
    } else {
      setRegisterAlert({
        open: true,
        type: 'warning',
        message: 'Dette ser ut som et duplikat. Hvis ikke det stemmer, last inn siden på nytt',
      });
    }
  };

  return (
    <>
      <Typography variant="h4" sx={{ fontWeight: 'bold' }} gutterBottom>
        Registrer
      </Typography>
      <Typography variant="body1" gutterBottom>
        Registrer spilletid på denne siden ⚽️
      </Typography>
      <Stack spacing={2} mt={3}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <MobileDatePicker
            label="Dato"
            maxDate={new Date()}
            inputFormat="dd.MM.yyyy"
            value={registerObj.date}
            onChange={(newDate) => setRegisterObj({ ...registerObj, date: newDate })}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '2em' }}>
          <TextField
            variant="outlined"
            label="Timer"
            type="number"
            value={registerObj.hours}
            onChange={({ target }) => setRegisterObj({ ...registerObj, hours: target.value })}
          />
          <TextField
            variant="outlined"
            label="Minutter"
            type="number"
            value={registerObj.minutes}
            onChange={({ target }) => setRegisterObj({ ...registerObj, minutes: target.value })}
          />
        </Box>
        <Button onClick={() => registerPlaytime(registerObj)} variant="contained" color="primary" size="large">
          Registrer tid
        </Button>
        {registerAlert.open && <Alert severity={registerAlert.type}>{registerAlert.message}</Alert>}
      </Stack>
    </>
  );
};

export default Register;
